import Spinner from 'react-bootstrap/Spinner';

function BorderSpinner() {
  return <Spinner animation="border" />;
}

export default BorderSpinner;